<template>
    <v-app id="app">
        <v-main div class="content">
            <router-view/>
            <v-container class="d-flex flex-column">
                <v-row class="text-md-left align-self-center">
                    <v-col class="col-12 text-md-left align-self-center py-16">
                        <div>
                            <p class="text-center">© 2023 Nicky Lim Yean Fen ❤️</p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app >
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="scss">
    @import '@/App.scss';

    *, html {
        scroll-behavior: smooth !important;
    }

    #app {
        font-family: $secondary-font-family;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        position: relative;
        background-color: black;
        color: $grey-color-100;

        h1,h2,h3,h4 {
            color: $blue-grey-color-50;
        }
    }

    .main {
        background: black;
        color: $blue-grey-color-50;
        position: relative;
        width: 100%;
    }

    .link {
        font-weight: 500;
        text-transform: uppercase;
        font-size: 14px;
    }

    .container {
        position: relative !important;
        max-width: 1200px !important;
    }

    .container-box{
        background: $grey-color-800 !important;
        border-radius: 24px !important;
        border: 1px solid $grey-color-700 !important;
        padding: 48px;
        min-height: 500px;
    }

    .header {
        position: fixed !important;
        top: 60px;
        z-index: 999;
        width: 100% !important;
        padding: 0 40px;
        max-width: none !important;
    }

	.footer-bg {
		width: 100vw;
		position: relative;
		background: url('~@/assets/images/theme/footer-bg-new.png') no-repeat top center;
        background-size: cover;
	}

    .theme--light{
        .v-footer {
            background-color: $grey-color-900;
        }
    }
    
    a {
        color: white !important;
        text-decoration: none;
        transition: ease .3s;

        &:hover {
            color: $teal-color-200 !important;
        }
    }

    .card-end {
        min-height: 350px;
    }

    ::-moz-selection { /* Code for Firefox */
        color: $grey-color-800;
        background: white;
    }

    ::selection {
        color: $grey-color-800;
        background: white;
    }


    @media only screen and (max-width: 600px) {
        .header {
            position: absolute !important;
            z-index: 999;
            padding: 0 16px;
            top: 32px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue